import {
  fetchCampaignKiosksGraphQL,
  fetchCampaignBillingInfoGraphQL,
  fetchCampaignUsersGraphQL
} from './graphql/campaignDetailsGraphQL';

import {
  parseCampaignKiosksFromGraphQL,
  parseCampaignBillingInfoFromGraphQL,
  parseCampaignUsersFromGraphQL
} from '../services/campaignDetailsGraphQLServices';

/**
 * Fetch and parse campaign kiosks/placements with pagination
 */
export const fetchGetCampaignKiosks = async (campaignId, paginationOptions = {}) => {
  const kioskData = await fetchCampaignKiosksGraphQL(campaignId, paginationOptions);
  return parseCampaignKiosksFromGraphQL(kioskData);
};

/**
 * Fetch and parse campaign billing info
 */
export const fetchGetCampaignBillingInfo = async (campaignId) => {
  const billingInfo = await fetchCampaignBillingInfoGraphQL(campaignId);
  return parseCampaignBillingInfoFromGraphQL(billingInfo);
};

/**
 * Fetch and parse campaign team/users
 */
export const fetchGetCampaignUsers = async (campaignId) => {
  const users = await fetchCampaignUsersGraphQL(campaignId);
  return parseCampaignUsersFromGraphQL(users);
};

